import { useLocation } from "react-router-dom";

export const useNavigationOrigin = () => {
    const { state } = useLocation<{ navigationOrigin?: string } | undefined>();
    return state?.navigationOrigin ?? "URL";
};
